
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'SToggle',
  components: {},
  props: {},

  setup(props, { attrs }) {
    const classes = computed(() => {
      const result = 's-toggle ';
      // result += `${props?.value ? 's-btn__active' : 's-btn__unactive'} `;
      return result;
    });

    return { classes };
  },
});
